/* DISTRIBUSI HP — CATAT: the + menu's forms as full screens without the dock (boards 3b / 3c). Same
   office endpoints, caps and rules as the old Input Transaksi form (DistTransactions / GantiRugiForm);
   the summary + Save stay above the keyboard. Penjualan, Bayar Bon, Ganti Rugi, Pengeluaran. */

// One idempotency key per form + customer: a double tap or a retry after a timeout saves once.
function dhpClientRef() {
  try { if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID(); } catch (e) { /* older browsers */ }
  return 'h' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
}
const dhpRecentKey = (uid) => 'airro.dist.hpRecent.' + (uid || 'anon');
function dhpRecentGet(uid) { try { const v = JSON.parse(localStorage.getItem(dhpRecentKey(uid)) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
function dhpRecentPush(uid, id) { try { localStorage.setItem(dhpRecentKey(uid), JSON.stringify(HPLOGIC.pushRecent(dhpRecentGet(uid), id))); } catch (e) { /* private mode */ } }
// FldPhoto uploads through `api.uploadPhoto`: the office attachments endpoint (not the field-tagged one).
const DHP_PHOTO_API = { uploadPhoto: (b) => window.API.attachments.create(b).then((r) => (r && r.data) || r) };
const dhpRp = (n) => FIELDLOGIC.fmtRp(Number(n) || 0);
// "Hari ini, 27 Okt" / "Sen, 26 Okt" (board 3b) — the native date picker sits invisibly on top of it.
const dhpDateLabel = (iso, today) => {
  let d = iso;
  try { d = dhpDateFmt(new Date(iso + 'T00:00'), iso === today ? { day: 'numeric', month: 'short' } : { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { d = iso; }
  return iso === today ? trDh('dhp.todayD', { d }) : d;
};
const dhpIni = (name) => String(name || '?').trim().split(/\s+/).slice(0, 2).map((w) => w.charAt(0)).join('').toUpperCase();
// a money input as wide as its number, so "Rp" sits right beside it
const dhpFit = (shown) => ({ width: Math.max(2, String(shown || '').length + 1) + 'ch' });
const dhpDigits = (s) => { const n = parseInt(String(s == null ? '' : s).replace(/[^0-9]/g, '').slice(0, 10), 10); return Number.isFinite(n) ? n : 0; };

// Pilih pelanggan (3c): full screen, the search box focused and raised above the keyboard, recent picks
// first, rows ≥ 52 px with the full name and the bon owed. accept(c) → '' or the reason it can't be used.
function DhpPickCustomer({ title, accept, onPick, onBack, userId }) {
  useDhpKbInset();
  const scrollRef = uRdh(null);
  const [all, setAll] = uSdh(null);
  const [err, setErr] = uSdh('');
  const [q, setQ] = uSdh('');
  uEdh(() => {
    let live = true;
    window.API.distribusi.customers.list().then((r) => { if (live) setAll((r && r.data) || []); }).catch((e) => { if (live) setErr(fldErrMsg(e)); });
    return () => { live = false; };
  }, []);
  const rows = uMdh(() => (all ? FIELDLOGIC.customerList(all, { q }).rows : []), [all, q]);
  const win = useDhpWindow(scrollRef, rows.length, q, 30, 50);   // all customers at once froze the screen on open
  const recent = all && !q.trim() ? dhpRecentGet(userId).map((id) => all.find((c) => c.id === id)).filter(Boolean) : [];
  const row = (c) => {
    const why = accept ? accept(c) : '';
    const bon = Number(c.sisaBon) || 0;
    return (
      <button key={c.id} type="button" className="dhp-rowi" disabled={!!why} onClick={() => { dhpRecentPush(userId, c.id); onPick(c); }}>
        <span className="dhp-grow"><span className="dhp-nm">{c.name}</span><span className="dhp-sbt">{why ? trDh(why) : [c.code, c.armada].filter(Boolean).join(' · ')}</span></span>
        {bon > 0 ? <span className="dhp-tag bon">{trDh('dhp.bonRp', { rp: dhpRp(bon) })}</span> : <span className="dhp-sbt">{trDh('dhp.lunas')}</span>}
      </button>
    );
  };
  return (
    <div ref={scrollRef} className="dhp-tok dhp-entry">
      <DhpTop title={title || trDh('dhp.pickCust')} onBack={onBack} />
      <div className="dhp-entry-body dhp-pickbody">
        {err ? <div className="mlap-err" role="alert">{err}</div> : null}
        {!all && !err ? <div className="mlap-empty">{trDh('dhp.loading')}</div> : null}
        {recent.length ? <><div className="dhp-lbl dhp-lbl-pad">{trDh('dhp.recent')}</div><div className="mlap-card dhp-card">{recent.map(row)}</div></> : null}
        {all ? <><div className="dhp-lbl dhp-lbl-pad">{q.trim() ? trDh('dhp.results', { n: rows.length }) : trDh('dhp.allCust')}</div>
          <div className="mlap-card dhp-card">{rows.length ? rows.slice(0, win.vis).map(row) : <div className="mlap-empty">{trDh('dhp.noCust')}</div>}</div>
          {win.more ? <div ref={win.sentinel} className="dhp-sentinel" /> : null}</> : null}
      </div>
      <DhpSearchPill value={q} onChange={setQ} placeholder={trDh('dhp.searchCust')} autoFocus raised />
    </div>
  );
}

// The frame every Catat form shares (board 3b): glass "Batal" + title, the cards, and the CTA bar with the
// summary line + Save, kept above the keyboard. After a save: what was saved + "Simpan & tambah lagi".
function DhpForm({ title, onClose, sum, total, busy, problem, saveLabel, onSave, saved, onAgain, children }) {
  useDhpKbInset();
  return (
    <div className="dhp-tok dhp-entry">
      <DhpTop title={title} onBack={onClose} backKind="pill" />
      <div className="dhp-entry-body">
        {children}
        <div className="mlap-ctaspace dhp-ctaspace" />
      </div>
      <FldCtaBar>
        {saved ? (
          <>
            <div className="dhp-saved" role="status"><FldSvg n="check" s={18} sw={2.4} />{saved}</div>
            <div className="dhp-ctarow">
              <button type="button" className="mlap-btn" onClick={onClose}>{trDh('dhp.done')}</button>
              <button type="button" className="mlap-btn primary" onClick={onAgain}>{trDh('dhp.saveAgain')}</button>
            </div>
          </>
        ) : (
          <>
            <div className="dhp-sumline"><small>{problem ? trDh(problem) : sum}</small>{total != null ? <b>{dhpRp(total)}</b> : null}</div>
            <button type="button" className="mlap-btn primary" disabled={busy || !!problem} onClick={onSave}>{busy ? trDh('dhp.saving') : saveLabel}</button>
          </>
        )}
      </FldCtaBar>
    </div>
  );
}

// The customer row at the top of a form (board 3b): tap → Pilih pelanggan.
function DhpCustRow({ cust, onPick, extra }) {
  return (
    <div className="mlap-card dhp-card">
      <button type="button" className="dhp-fld" onClick={onPick}>
        {cust ? <span className="dhp-ini sm">{dhpIni(cust.name)}</span> : null}
        <span className="dhp-lb">{cust ? cust.name : trDh('dhp.pickCust')}
          {cust ? <small>{[cust.code, (Number(cust.sisaBon) || 0) > 0 ? trDh('dhp.sisaBonRp', { rp: dhpRp(cust.sisaBon) }) : '', trDh('dhp.galonN', { n: Number(cust.gallonsHeld) || 0 })].filter(Boolean).join(' · ')}</small> : null}
        </span>
        <FldSvg n="right" s={16} />
      </button>
      {extra}
    </div>
  );
}
// Tanggal (locked to today for staff, as the old form) + Catatan.
function DhpDateNote({ date, setDate, today, staffMode, note, setNote, noteMax }) {
  return (
    <div className="mlap-card dhp-card">
      <label className="dhp-fld dhp-datefld"><span className="dhp-lb">{trDh('dhp.dateLbl')}</span>
        <span className="dhp-v">{dhpDateLabel(staffMode ? today : date, today)}</span>
        {staffMode ? null : <input className="dhp-date-over" type="date" value={date} max={today} aria-label={trDh('dhp.dateLbl')} onChange={(e) => setDate(e.target.value || today)} />}</label>
      <label className="dhp-fld"><span className="dhp-lb">{trDh('dhp.noteLbl')}</span>
        <input className="dhp-txt" value={note} maxLength={noteMax || 300} placeholder={trDh('dhp.optional')} onChange={(e) => setNote(e.target.value)} /></label>
    </div>
  );
}
// Choice cards (board 3b .payg): options [[key, labelKey, subKey]].
function DhpChoice({ options, value, onChange, label, cols }) {
  return (
    <div className={'dhp-payg' + (cols ? ' c' + cols : '')} role="radiogroup" aria-label={label}>
      {options.map(([k, t, s]) => <button key={k} type="button" role="radio" aria-checked={value === k} className={value === k ? 'on' : ''} onClick={() => onChange(k)}>{trDh(t)}{s ? <small>{trDh(s)}</small> : null}</button>)}
    </div>
  );
}
function DhpMoneyRow({ label, value, onChange }) {
  return (
    <label className="dhp-fld"><span className="dhp-lb">{label}</span>
      <span className="dhp-money"><span aria-hidden="true">Rp</span><input className="dhp-num wide" inputMode="numeric" aria-label={label} style={dhpFit(value ? Number(value).toLocaleString('id-ID') : '')} value={value ? Number(value).toLocaleString('id-ID') : ''} placeholder="0" onChange={(e) => onChange(dhpDigits(e.target.value))} /></span></label>
  );
}

// Penjualan (3b).
function DhpSaleForm({ cust, onPickCust, rules, today, date: start, staffMode, afterSave, onDone, onClose }) {
  const [qty, setQty] = uSdh(1);
  const [out, setOut] = uSdh(1);
  const [inn, setInn] = uSdh(0);   // empties returned: 0 by default, as the old office form (fGalIn)
  const [outTouched, setOutTouched] = uSdh(false);
  const [pay, setPay] = uSdh('lunas');
  const [date, setDate] = uSdh(start || today);   // a stop on another day's board sells on that day
  const [note, setNote] = uSdh('');
  const [photo, setPhoto] = uSdh(null);
  const [ref, setRef] = uSdh(dhpClientRef);
  const [ask, setAsk] = uSdh(false);
  const [busy, setBusy] = uSdh(false);
  const [err, setErr] = uSdh('');
  const [saved, setSaved] = uSdh('');
  uEdh(() => { setRef(dhpClientRef()); setSaved(''); setErr(''); }, [cust && cust.id]);   // a new customer is a new sale
  const needPhoto = !!(rules && rules.wajibFotoTransaksi);
  const price = cust ? cust.masterPrice : 0;
  const total = HPLOGIC.saleTotal(qty, price);
  const problem = HPLOGIC.saleProblem({ cust, qty, needPhoto, photo });
  const changeQty = (v) => { setQty(v); if (!outTouched) setOut(v); };
  const payLabel = trDh(pay === 'bon' ? 'dhp.payBon' : pay === 'transfer' ? 'dhp.payTf' : 'dhp.payLunas');
  const save = () => {
    setAsk(false); setBusy(true); setErr('');
    window.API.distribusi.transactions.create(HPLOGIC.saleBody({ cust, qty, out, inn, pay, note, date: staffMode ? today : date, ref: ref, photo }))
      .then((r) => { const t = (r && r.data) || r; setSaved(trDh('dhp.savedSale', { name: cust.name, rp: dhpRp(total) })); if (afterSave) afterSave(t); if (onDone) onDone(t); })
      .catch((e) => setErr(fldErrMsg(e)))
      .finally(() => setBusy(false));
  };
  const again = () => { setQty(1); setOut(1); setInn(0); setOutTouched(false); setNote(''); setPhoto(null); setSaved(''); setRef(dhpClientRef()); onPickCust(); };
  return (
    <DhpForm title={trDh('dhp.cSale')} onClose={onClose} busy={busy} problem={problem} saveLabel={trDh('dhp.saveSale')} onSave={() => setAsk(true)} saved={saved} onAgain={again}
      sum={cust ? trDh('dhp.saleSum', { q: qty, rp: dhpRp(price), pay: payLabel }) : ''} total={total}>
      <DhpCustRow cust={cust} onPick={onPickCust}
        extra={cust ? <div className="dhp-fld"><span className="dhp-lb sub"><FldSvg n="lock" s={14} /> {trDh('dhp.priceLocked')}</span><span className="dhp-v">{trDh('dhp.perGalon', { rp: dhpRp(price) })}</span></div> : null} />
      <div className="dhp-lbl dhp-lbl-pad">{trDh('dhp.qtyLbl')}</div>
      <div className="mlap-card dhp-card">
        <FldStepper value={qty} onChange={changeQty} min={0} max={999} cls="big teal" />
        <label className="dhp-fld"><span className="dhp-lb">{trDh('dhp.outLbl')}</span>
          <input className="dhp-num" inputMode="numeric" value={out} onChange={(e) => { setOutTouched(true); setOut(dhpDigits(e.target.value)); }} /></label>
        <label className="dhp-fld"><span className="dhp-lb">{trDh('dhp.inLbl')}</span>
          <input className="dhp-num" inputMode="numeric" value={inn} onChange={(e) => setInn(dhpDigits(e.target.value))} /></label>
      </div>
      <div className="dhp-lbl dhp-lbl-pad">{trDh('dhp.payLbl')}</div>
      <DhpChoice label={trDh('dhp.payLbl')} value={pay} onChange={setPay} options={[['lunas', 'dhp.payLunas', 'dhp.payLunasSub'], ['transfer', 'dhp.payTf', 'dhp.payTfSub'], ['bon', 'dhp.payBon', 'dhp.payBonSub']]} />
      {needPhoto ? <FldPhoto api={DHP_PHOTO_API} value={photo} onChange={setPhoto} /> : null}
      <DhpDateNote date={date} setDate={setDate} today={today} staffMode={staffMode} note={note} setNote={setNote} />
      {err ? <div className="mlap-err dhp-err" role="alert">{err}</div> : null}
      {ask ? <FldSheet title={trDh('dhp.saleAskT')} body={trDh('dhp.saleAskB', { name: cust.name, q: qty, pay: payLabel, rp: dhpRp(total) })} confirmLabel={trDh('dhp.saveSale')} onClose={() => setAsk(false)} onConfirm={save} /> : null}
    </DhpForm>
  );
}

// Bayar Bon (pelunasan) — same endpoint + body as the old Pelunasan tab, never more than the sisa bon.
function DhpBonForm({ cust, onPickCust, rules, today, staffMode, onDone, onClose }) {
  const [amount, setAmount] = uSdh(0);
  const [targets, setTargets] = uSdh([]);   // pelunasan untuk bon tertentu ([] = bon paling lama dulu)
  const [pay, setPay] = uSdh('tunai');
  const [date, setDate] = uSdh(today);
  const [note, setNote] = uSdh('');
  const [photo, setPhoto] = uSdh(null);
  const [ref, setRef] = uSdh(dhpClientRef);
  const [busy, setBusy] = uSdh(false);
  const [err, setErr] = uSdh('');
  const [saved, setSaved] = uSdh('');
  uEdh(() => { setRef(dhpClientRef()); setSaved(''); setErr(''); setAmount(0); setTargets([]); }, [cust && cust.id]);
  const needPhoto = !!(rules && rules.wajibFotoTransaksi);
  const sisa = cust ? Number(cust.sisaBon) || 0 : 0;
  const problem = HPLOGIC.bonProblem({ cust, amount, needPhoto, photo });
  const save = () => {
    setBusy(true); setErr('');
    window.API.distribusi.transactions.create(HPLOGIC.bonBody({ cust, amount, pay, note, date: staffMode ? today : date, ref: ref, photo, targets }))
      .then((r) => { const t = (r && r.data) || r; setSaved(trDh('dhp.savedBon', { name: cust.name, rp: dhpRp(amount), sisa: dhpRp(t && t.sisaBon != null ? t.sisaBon : sisa - amount) })); if (onDone) onDone(t); })
      .catch((e) => setErr(fldErrMsg(e)))
      .finally(() => setBusy(false));
  };
  const again = () => { setNote(''); setPhoto(null); setSaved(''); setTargets([]); setRef(dhpClientRef()); onPickCust(); };
  return (
    <DhpForm title={trDh('dhp.cBon')} onClose={onClose} busy={busy} problem={problem} saveLabel={trDh('dhp.saveBon')} onSave={save} saved={saved} onAgain={again}
      sum={trDh('dhp.bonSum', { pay: trDh(pay === 'transfer' ? 'dhp.payTf' : 'dhp.payLunasSub'), sisa: dhpRp(Math.max(0, sisa - amount)) })} total={amount}>
      <DhpCustRow cust={cust} onPick={onPickCust} />
      <div className="mlap-card dhp-card">
        <div className="dhp-fld"><span className="dhp-lb sub">{trDh('dhp.sisaBon')}</span><span className="dhp-v dhp-bon">{dhpRp(sisa)}</span></div>
        <DhpMoneyRow label={trDh('dhp.payAmt')} value={amount} onChange={setAmount} />
        {sisa > 0 && amount !== sisa ? <button type="button" className="dhp-fld dhp-link" onClick={() => setAmount(sisa)}>{trDh('dhp.payAll', { rp: dhpRp(sisa) })}</button> : null}
      </div>
      {cust && sisa > 0 ? <div className="mlap-card dhp-card dhp-bt"><BonTargetPicker customerId={cust.id} value={targets} onChange={setTargets} amount={amount} onUseSum={(n) => setAmount(Math.min(sisa, n))} /></div> : null}
      <div className="dhp-lbl dhp-lbl-pad">{trDh('dhp.payLbl')}</div>
      <DhpChoice cols={2} label={trDh('dhp.payLbl')} value={pay} onChange={setPay} options={[['tunai', 'dhp.payLunasSub', ''], ['transfer', 'dhp.payTf', 'dhp.payTfSub']]} />
      {needPhoto ? <FldPhoto api={DHP_PHOTO_API} value={photo} onChange={setPhoto} /> : null}
      <DhpDateNote date={date} setDate={setDate} today={today} staffMode={staffMode} note={note} setNote={setNote} />
      {err ? <div className="mlap-err dhp-err" role="alert">{err}</div> : null}
    </DhpForm>
  );
}

// Ganti Rugi — the same plan (DISTGR.planGantiRugi), rules and body as GantiRugiForm: owner's price, the
// office may negotiate the total, the damage photo is required unless distribusiGantiRugiTanpaFoto.
function DhpDamageForm({ cust, onPickCust, perms, rules, today, staffMode, onDone, onClose }) {
  const p = perms || {};
  const [held, setHeld] = uSdh(null);
  const [qty, setQty] = uSdh(1);
  const [kind, setKind] = uSdh('');
  const [pay, setPay] = uSdh('tunai');
  const [totalStr, setTotalStr] = uSdh(null);   // null = follow qty × owner price; a string = typed by the office
  const [date, setDate] = uSdh(today);
  const [note, setNote] = uSdh('');
  const [tfPhoto, setTfPhoto] = uSdh(null);
  const [dmgPhoto, setDmgPhoto] = uSdh(null);
  const [ref, setRef] = uSdh(dhpClientRef);
  const [busy, setBusy] = uSdh(false);
  const [err, setErr] = uSdh('');
  const [saved, setSaved] = uSdh('');
  uEdh(() => {
    setHeld(null); setRef(dhpClientRef()); setSaved(''); setErr('');
    if (!cust) return undefined;
    let live = true;
    window.API.distribusi.customers.get(cust.id).then((r) => { if (live) setHeld(Number((r && r.data && r.data.gallonsHeld) || 0)); }).catch(() => { if (live) setHeld(0); });
    return () => { live = false; };
  }, [cust && cust.id]);
  const price = rules ? Number(rules.hargaGantiRugiGalon || 0) : null;
  const money = pay !== 'ganti_galon';
  const plan = DISTGR.planGantiRugi({ qty, ownerPrice: price || 0, total: totalStr == null ? null : grDigits(totalStr), pay, hasTransferProof: !!(tfPhoto && tfPhoto.id), office: true, canNego: !!p.distribusiGantiRugiHarga, selfLimit: +p.maxSelfApproveAmount || 0 });
  const needPhoto = !p.distribusiGantiRugiTanpaFoto;
  const problem = HPLOGIC.damageProblem({ cust, kind, qty, held, price, plan, needPhoto, dmgPhoto });
  const save = () => {
    setBusy(true); setErr('');
    window.API.distribusi.gantiRugi.create(cust.id, HPLOGIC.damageBody({ qty, kind, pay, date: staffMode ? today : date, ref: ref, plan, tfPhoto, dmgPhoto, note }))
      .then((r) => { setSaved(trDh('dhp.savedDamage', { name: cust.name, n: qty })); if (onDone) onDone(r && r.data); })
      .catch((e) => setErr(grErr(e)))
      .finally(() => setBusy(false));
  };
  const again = () => { setQty(1); setKind(''); setTotalStr(null); setNote(''); setTfPhoto(null); setDmgPhoto(null); setSaved(''); setRef(dhpClientRef()); onPickCust(); };
  const kindLabel = kind ? trDh((GR_KINDS.find((k) => k[0] === kind) || [])[1]) : '';
  const shownTotal = totalStr != null ? totalStr : (plan.ownerAmount ? plan.ownerAmount.toLocaleString('id-ID') : '');
  return (
    <DhpForm title={trDh('dhp.cDamage')} onClose={onClose} busy={busy} problem={problem === 'gr.errQty' ? '' : problem} saveLabel={trDh('dhp.saveDamage')} onSave={save} saved={saved} onAgain={again}
      sum={[trDh('dhp.galonQty', { n: qty }), kindLabel, trDh((GR_PAYS.find((k) => k[0] === pay) || [])[1])].filter(Boolean).join(' · ')} total={money ? plan.amount : null}>
      <DhpCustRow cust={cust} onPick={onPickCust}
        extra={cust ? <div className="dhp-fld"><span className="dhp-lb sub">{trDh('gr.held')}</span><span className="dhp-v">{held == null ? '…' : held}</span></div> : null} />
      <div className="dhp-lbl dhp-lbl-pad">{trDh('gr.qty')}</div>
      <div className="mlap-card dhp-card"><FldStepper value={qty} onChange={setQty} min={1} max={Math.max(1, held || 999)} cls="big teal" /></div>
      {problem === 'gr.errQty' ? <div className="mlap-err dhp-err" role="alert">{trDh('gr.errQty', { n: held })}</div> : null}
      <div className="dhp-lbl dhp-lbl-pad">{trDh('gr.kind')}</div>
      <DhpChoice cols={4} label={trDh('gr.kind')} value={kind} onChange={setKind} options={GR_KINDS.map(([k, key]) => [k, key, ''])} />
      <div className="dhp-lbl dhp-lbl-pad">{trDh('gr.pay')}</div>
      <DhpChoice cols={2} label={trDh('gr.pay')} value={pay} onChange={setPay} options={GR_PAYS.map(([k, key]) => [k, key, ''])} />
      {money ? (
        <div className="mlap-card dhp-card">
          <label className="dhp-fld"><span className="dhp-lb">{trDh('gr.total')}<small>{trDh('gr.ownerPrice')}: {dhpRp(price)} × {qty} = {dhpRp(plan.ownerAmount)}</small></span>
            <span className="dhp-money"><span aria-hidden="true">Rp</span><input className="dhp-num wide" inputMode="numeric" style={dhpFit(shownTotal)} value={shownTotal} placeholder="0" aria-label={trDh('gr.total')} onChange={(e) => setTotalStr(e.target.value.replace(/[^0-9]/g, ''))} /></span></label>
          {plan.nego ? <div className="dhp-fld"><span className="dhp-lb sub">{trDh(plan.negoApplyNow ? 'gr.negoSelf' : 'gr.negoWait')}</span></div> : null}
          {plan.sisaBonAdd > 0 ? <div className="dhp-fld"><span className="dhp-lb sub">{trDh('gr.toBon')}</span><span className="dhp-v dhp-bon">{dhpRp(plan.sisaBonAdd)}</span></div> : null}
        </div>
      ) : <div className="mlap-card dhp-card"><div className="dhp-fld"><span className="dhp-lb sub">{trDh('gr.replaceNote', { n: qty })}</span></div></div>}
      {pay === 'transfer' ? <FldPhoto api={DHP_PHOTO_API} gallery optional value={tfPhoto} onChange={setTfPhoto} title={trDh('gr.tfProof')} hintKey="dhp.tfProofHint" /> : null}
      <FldPhoto api={DHP_PHOTO_API} value={dmgPhoto} onChange={setDmgPhoto} optional={!needPhoto} title={trDh(needPhoto ? 'gr.dmgPhotoReq' : 'gr.dmgPhoto')} hintKey="dhp.dmgPhotoHint" />
      <DhpDateNote date={date} setDate={setDate} today={today} staffMode={staffMode} note={note} setNote={setNote} noteMax={200} />
      {err ? <div className="mlap-err dhp-err" role="alert">{err}</div> : null}
    </DhpForm>
  );
}

// Pengeluaran — same endpoint + body as the old Pengeluaran tab; a typo-sized amount is confirmed first.
function DhpExpenseForm({ rules, today, staffMode, fleet, fleetScope, onDone, onClose }) {
  const scoped = Array.isArray(fleetScope);
  const plates = scoped ? (fleetScope || []).filter(Boolean) : (fleet || []).filter(Boolean);
  const [cats, setCats] = uSdh(['bensin', 'makan', 'parkir', 'lainnya']);
  const [cat, setCat] = uSdh('bensin');
  const [custom, setCustom] = uSdh(false);
  const [fl, setFl] = uSdh(scoped && plates.length === 1 ? plates[0] : '');
  const [amount, setAmount] = uSdh(0);
  const [method, setMethod] = uSdh('tunai');
  const [date, setDate] = uSdh(today);
  const [recipient, setRecipient] = uSdh('');
  const [note, setNote] = uSdh('');
  const [photo, setPhoto] = uSdh(null);
  const [ref, setRef] = uSdh(dhpClientRef);
  const [askBig, setAskBig] = uSdh(false);
  const [busy, setBusy] = uSdh(false);
  const [err, setErr] = uSdh('');
  const [saved, setSaved] = uSdh('');
  uEdh(() => { window.API.distribusi.expenses.categories().then((r) => { if (r && r.data && r.data.length) setCats(r.data); }).catch(() => { /* keep the defaults */ }); }, []);
  const needPhoto = !!(rules && rules.wajibFotoPengeluaran);
  const problem = HPLOGIC.expenseProblem({ amount, scoped, fleet: fl, needPhoto, photo });
  const catLabel = (c) => { const k = 'exp.cat_' + c; const t = trDh(k); return t !== k ? t : c; };
  const save = () => {
    setAskBig(false); setBusy(true); setErr('');
    window.API.distribusi.expenses.create(HPLOGIC.expenseBody({ date: staffMode ? today : date, fleet: fl, amount, category: cat, method, recipient, note, photo, ref: ref }))
      .then((r) => { setSaved(trDh('dhp.savedExpense', { cat: catLabel(cat), rp: dhpRp(amount) })); if (onDone) onDone(r && r.data); })
      .catch((e) => setErr(fldErrMsg(e)))
      .finally(() => setBusy(false));
  };
  const again = () => { setAmount(0); setRecipient(''); setNote(''); setPhoto(null); setSaved(''); setRef(dhpClientRef()); };
  return (
    <DhpForm title={trDh('dhp.cExpense')} onClose={onClose} busy={busy} problem={problem} saveLabel={trDh('dhp.saveExpense')} onSave={() => (amount > WARN_AMOUNT ? setAskBig(true) : save())}
      saved={saved} onAgain={again} sum={[catLabel(cat), fl, trDh(method === 'transfer' ? 'dhp.payTf' : 'dhp.payLunasSub')].filter(Boolean).join(' · ')} total={amount}>
      {!scoped || plates.length > 1 ? (<>
        <div className="dhp-lbl dhp-lbl-pad">{trDh('dhp.fleetLbl')}</div>
        <div className="dhp-wrap">{plates.map((f) => <button key={f} type="button" className={'dhp-chip' + (fl === f ? ' on' : '')} aria-pressed={fl === f} onClick={() => setFl(f)}>{f}</button>)}</div>
      </>) : null}
      <div className="dhp-lbl dhp-lbl-pad">{trDh('exp.category')}</div>
      <div className="dhp-wrap">
        {cats.map((c) => <button key={c} type="button" className={'dhp-chip' + (!custom && cat === c ? ' on' : '')} aria-pressed={!custom && cat === c} onClick={() => { setCustom(false); setCat(c); }}>{catLabel(c)}</button>)}
        <button type="button" className={'dhp-chip' + (custom ? ' on' : '')} aria-pressed={custom} onClick={() => { setCustom(true); setCat(''); }}>{trDh('exp.catCustom')}</button>
      </div>
      <div className="mlap-card dhp-card">
        {custom ? <label className="dhp-fld"><span className="dhp-lb">{trDh('exp.category')}</span><input className="dhp-txt" value={cat} maxLength={40} onChange={(e) => setCat(e.target.value)} /></label> : null}
        <DhpMoneyRow label={trDh('dhp.amount')} value={amount} onChange={setAmount} />
        <label className="dhp-fld"><span className="dhp-lb">{trDh('dhp.recipient')}</span><input className="dhp-txt" value={recipient} maxLength={120} placeholder={trDh('dhp.optional')} onChange={(e) => setRecipient(e.target.value)} /></label>
      </div>
      <div className="dhp-lbl dhp-lbl-pad">{trDh('dhp.payLbl')}</div>
      <DhpChoice cols={2} label={trDh('dhp.payLbl')} value={method} onChange={setMethod} options={[['tunai', 'dhp.payLunasSub', ''], ['transfer', 'dhp.payTf', '']]} />
      <FldPhoto api={DHP_PHOTO_API} value={photo} onChange={setPhoto} optional={!needPhoto} title={trDh('dhp.receipt')} hintKey="dhp.receiptHint" />
      <DhpDateNote date={date} setDate={setDate} today={today} staffMode={staffMode} note={note} setNote={setNote} />
      {err ? <div className="mlap-err dhp-err" role="alert">{err}</div> : null}
      {askBig ? <FldSheet title={trDh('dhp.bigAskT')} body={trDh('dhp.bigAskB', { rp: dhpRp(amount) })} confirmLabel={trDh('dhp.saveExpense')} danger onClose={() => setAskBig(false)} onConfirm={save} /> : null}
    </DhpForm>
  );
}

// The Catat host: which form, and the customer picker on top of it (Pengeluaran has no customer).
function DhpEntry({ kind, cust, date, afterSave, perms, rules, today, staffMode, userId, fleet, fleetScope, onDone, onClose }) {
  const needsCust = kind !== 'expense';
  const [c, setC] = uSdh(cust || null);
  const [picking, setPicking] = uSdh(needsCust && !cust);
  if (picking) {
    const accept = kind === 'bon' ? (x) => ((Number(x.sisaBon) || 0) > 0 ? '' : 'dhp.noBon') : null;
    return <DhpPickCustomer userId={userId} accept={accept} onPick={(x) => { setC(x); setPicking(false); }} onBack={() => (c ? setPicking(false) : onClose())} />;
  }
  const common = { cust: c, onPickCust: () => setPicking(true), perms, rules, today, staffMode, onDone, onClose };
  if (kind === 'sale') return <DhpSaleForm {...common} date={date} afterSave={afterSave} />;
  if (kind === 'bon') return <DhpBonForm {...common} />;
  if (kind === 'damage') return <DhpDamageForm {...common} />;
  if (kind === 'expense') return <DhpExpenseForm rules={rules} today={today} staffMode={staffMode} fleet={fleet} fleetScope={fleetScope} onDone={onDone} onClose={onClose} />;
  return null;
}
